// src/OfferPage.js

import React from "react";

export default function OfferPage() {
  const handleCheckout = async () => {
    const res = await fetch("https://reel-backend-y11o.onrender.com/create-checkout-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: localStorage.getItem("userEmail") || "unknown@example.com" }),
    });

    const data = await res.json();
    if (data?.url) {
      window.location.href = data.url;
    } else {
      alert("❌ Stripe checkout failed.");
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12 text-center">
      <h1 className="text-4xl font-bold mb-6 text-gray-900">🎯 Premium Membership</h1>
      <p className="text-lg text-gray-700 max-w-2xl mb-6">
        Get exclusive access to fresh weekly reels that keep your content pipeline full and your brand always relevant.
      </p>
      <ul className="text-left text-gray-700 mb-8 space-y-3">
        <li>✅ 7 new b-roll topics every single week</li>
        <li>✅ AI-generated voiceovers with your cloned voice</li>
        <li>✅ Access to your personal reel library anytime</li>
        <li>✅ Bonus scripts + marketing captions</li>
        <li>✅ First access to new features</li>
        <li>🚫 No editing, no guessing, no falling behind</li>
      </ul>
      <button
        onClick={handleCheckout}
        className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-xl font-semibold shadow-lg"
      >
        🔐 Unlock Weekly Reels – $39/month
      </button>
      <p className="mt-4 text-sm text-gray-500">
        Cancel anytime. Your subscription supports platform upgrades for agents like you.
      </p>
    </div>
  );
}
